import React, {useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import InputRange from '../../utils/InputRange2';
import CustomDropDown from '../../utils/CustomDropDown';
import Legals from '../components/Legals';
import ModelsList from '../components/Home/ModelsList';

import useConfiguratorData from '../hooks/useConfiguratorData';

const Home = () => {

    const { getModels, getFilters, getLoading, filter, setPreselectedDealerId } = useConfiguratorData();
    const location = useLocation();

    const models = getModels();
    const filters = getFilters();
    const loading = getLoading();

    useEffect(() => {
        if(!(models?.length>0))return;
        getMaxAndMinValues();
    }, [models])

    useEffect(() =>{
        const query = parseInt(new URLSearchParams(location.search).get('did'));
        setPreselectedDealerId(query);
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const gclid = urlParams.get('gclid');
        if (gclid && !sessionStorage.getItem('gclid')) {
            sessionStorage.setItem('gclid', gclid);
        }
        const utm_source = urlParams.get('utm_source');
        if (utm_source && !sessionStorage.getItem('utm_source')) {
            sessionStorage.setItem('utm_source', utm_source);
        }
        const utm_medium = urlParams.get('utm_medium');
        if (utm_medium && !sessionStorage.getItem('utm_medium')) {
            sessionStorage.setItem('utm_medium', utm_medium);
        }
        const utm_campaign = urlParams.get('utm_campaign');
        if (utm_campaign && !sessionStorage.getItem('utm_campaign')) {
            sessionStorage.setItem('utm_campaign', utm_campaign);
        }
    }, []);

    const [filterOptions, setFilterOptions] = useState({
        segment: {id: 0, name: "Todos"},
        motor: {id: 0, name: "Todos"},
        model: {id: 0, name: "Todos"},
        price: null
    })
    const [inputRangeProperties, setInputRangeProperties] = useState({
        valueText: "Precio",
        prefix: "$ ",
        minValue: 0,
        maxValue: 0,
        step: 1000
    })
    const [ checkboxValue, setCheckboxValue ] = useState(false);


    const getMaxAndMinValues = () => {
        if (models.length) {
            let ordered = models.sort((a,b)=>a.cheapest_price - b.cheapest_price);
            setInputRangeProperties(prevState => ({
                ...prevState,
                minValue: parseInt(ordered[0].cheapest_price || 0),
                maxValue: parseInt(ordered[ordered.length - 1].cheapest_price || 0),
                defaultValue: {min: parseInt(ordered[0].cheapest_price || 0), max:parseInt(ordered[ordered.length - 1].cheapest_price)},
            }));
            //Init price in filterOptions
            setFilterOptions(prevState => ({
                ...prevState,
                price: {
                    min: parseInt(ordered[0].cheapest_price || 0),
                    max: parseInt(ordered[ordered.length - 1].cheapest_price || 0),
                }
            }))
        }
    }

    const handleChangePrice = value => {
        let options = {...filterOptions};
        options.price = value;
        setFilterOptions(options);
        filter(options);
    };

    const handleChangeSegment = value => {
        let options = {...filterOptions};
        options.segment = value;
        setFilterOptions(options);
        filter(options);
    };

    const handleChangeModel = value => {
        let options = {...filterOptions};
        options.model = value;
        setFilterOptions(options);
        filter(options);
    };

    const handleChangeMotor = value => {
        let options = {...filterOptions};
        options.motor = value;
        setFilterOptions(options);
        filter(options);
        setCheckboxValue(false);
    };

    const handleCheckboxChange = (e) => {
        setCheckboxValue(e.target.checked);
        if(!checkboxValue) {
            let options = {...filterOptions};
            options.motor = {id: 2, name: "Híbrido"};
            setFilterOptions(options);
            filter(options);
        } else {
            let options = {...filterOptions};
            options.motor = {id: 0, name: "Todos"};
            setFilterOptions(options);
            filter(options);
        } 
    }

    return (
        <>
        {!loading ? 
            <div className="full-viewport-width home">
                <div className={checkboxValue ? "main-container home-container --blue" : "main-container home-container"}>
                    <h2 className="main-title">Mira, conoce y compara todos los vehículos</h2>
                    <InputRange 
                        {...inputRangeProperties} 
                        onChangeValue={handleChangePrice}
                        hybrid={checkboxValue}
                    />
                    <div className="select-group">
                        <CustomDropDown 
                            items={filters.segments} 
                            label="Tipo de vehículo" 
                            onClickOption={handleChangeSegment}
                        />
                        <CustomDropDown 
                            items={filters.models} 
                            label="Modelos"
                            onClickOption={handleChangeModel}
                        />
                        <CustomDropDown 
                            items={filters.motors} 
                            label="Combustible"
                            onClickOption={handleChangeMotor}
                        />
                        {/* <div className='custom-checkbox-container'>
                            <label className="custom-checkbox">
                                <input type="checkbox" checked={checkboxValue} onChange={(e) => handleCheckboxChange(e)} />
                                <span className="checkmark"></span>
                            </label>
                            <span className="checkbox-text" >Solo híbridos</span>

                        </div> */}
                    </div>
                    <ModelsList selectedMotor={filterOptions.motor} />
                </div>
                <Legals/>
            </div>
        : 
            <div className="spinner-container">
                <div className="spinner"></div>
            </div>
        }
        </>

    );
}

export default Home;
